// openCloseStatus.js
import cookieFinder from "./cookieFinder";

class OpenCloseStatus {
    constructor() {
        this.openChatPannel = "swithStatusChatPannel";
        this.buttonStatus = "buttonHiddenStatus";
        this.shadowRoot = window.shadowDOM.shadowRoot;
        this.init();
    }

    init() {
        // Get elements from shadow DOM
        const minimizeWindow = this.shadowRoot.querySelector("#minimizeWindow");
        const closeWindow = this.shadowRoot.querySelector("#closeWindow");
        const chatPannel = this.shadowRoot.querySelector(".bot-layout");
        const floatButton = this.shadowRoot.querySelector(".floatButon");

        if (minimizeWindow) {
            minimizeWindow.addEventListener("click", () => this.handleMinimize());
        }

        if (floatButton) {
            floatButton.addEventListener("click", () => this.handleFloat());
        }

        if (closeWindow) {
            closeWindow.addEventListener("click", () => this.handleClose());
        }
    }

    handleMinimize() {
        const floatButton = this.shadowRoot.querySelector(".floatButon");
        const chatPannel = this.shadowRoot.querySelector(".bot-layout");
        
        if (floatButton && chatPannel) {
            floatButton.classList.remove(this.buttonStatus);
            chatPannel.classList.add(this.openChatPannel);
        }
    }

    handleFloat() {
        const chatPannel = this.shadowRoot.querySelector(".bot-layout");
        const floatButton = this.shadowRoot.querySelector(".floatButon");
        
        if (chatPannel && floatButton) {
            chatPannel.classList.remove(this.openChatPannel);
            floatButton.classList.add(this.buttonStatus);
        }
    }

    handleClose() {
        const floatButton = this.shadowRoot.querySelector(".floatButon");
        const chatPannel = this.shadowRoot.querySelector(".bot-layout");

        if (floatButton && chatPannel) {
            floatButton.classList.remove(this.buttonStatus);
            chatPannel.classList.add(this.openChatPannel);
        }

        // Check for existing cookies
        const hasAnyCookie = cookieFinder(anyBacken.cookie);
        const hasHistoryCookie = cookieFinder(anyBacken.historyCookie);

        if (hasAnyCookie || hasHistoryCookie) {
            const confirmClose = window.confirm(
                "Deseas cerrar el chat?, no podrás recuperar la conversación!"
            );

            if (confirmClose) {
                this.clearCookiesAndReload();
            }
        }
    }

    clearCookiesAndReload() {
        jQuery.ajax({
            type: "POST",
            url: anyBacken.ajaxurl,
            data: {
                action: 'setCookie',
                clear: true,
                nonce: anyBacken.nonce
            },
            success: () => {
                this.deleteCookiesAndReload();
            },
            error: (err) => {
                console.error('Error clearing cookies:', err);
                this.deleteCookiesAndReload();
            }
        });
    }

    deleteCookiesAndReload() {
        const cookies = [anyBacken.cookie, anyBacken.historyCookie];
        const domain = window.location.hostname;

        cookies.forEach(cookieName => {
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}; Secure; SameSite=Strict`;
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${domain}; Secure; SameSite=Strict`;
            document.cookie = `${cookieName}=; max-age=0; path=/; domain=${domain}; Secure; SameSite=Strict`;
            document.cookie = `${cookieName}=; max-age=0; path=/;`;
        });

        setTimeout(() => {
            window.location.reload();
        }, 100);
    }
}

export default OpenCloseStatus;
